import { jsx as _jsx } from "react/jsx-runtime";
import { usePdpLink } from "@jti/rest-api";
import { AlertBanner } from "@jti/ui/components/AlertBanner";
import { useConfig } from "@jti/ui/providers/useConfig";
import { useTranslations } from "@jti/ui/providers/useTranslations";
export const TradeInAlertBanner = ({ cause, nonTradeInSku }) => {
    const { __ } = useTranslations();
    const config = useConfig();
    const pdpLink = usePdpLink(nonTradeInSku);
    const registerProductHref = config.REDIRECT_TO_DEVICE_REGISTRATION_ON_PROFILE;
    const relatedProductPageHref = pdpLink || config.SHOP_URL;
    const viewRelatedProductText = __("productdetails.tradein.error.view_related_device");
    const sharedProps = {
        title: __("productdetails.tradein.error.title"),
        withIconClose: false,
        variant: "warning",
        shouldCloseOnCtaClick: false,
    };
    if (cause === "not-eligible") {
        return (_jsx(AlertBanner, { description: __("productdetails.tradein.error.not_eligible.text"), buttonFirstText: viewRelatedProductText, firstButtonHref: relatedProductPageHref, ...sharedProps }));
    }
    return (_jsx(AlertBanner, { description: __("productdetails.tradein.error.device_not_registered.text"), buttonFirstText: __("productdetails.tradein.error.register"), firstButtonHref: registerProductHref, buttonSecondText: viewRelatedProductText, secondButtonHref: relatedProductPageHref, ...sharedProps }));
};
//# sourceMappingURL=TradeInAlertBanner.js.map